import React, { useEffect, useState } from 'react';
import {
  Box, Flex, Text, Button, Spinner, Center, HStack, Icon, Image,
} from '@chakra-ui/react';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import { supabase } from '../supabaseClient';

export default function FacilityLayout() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [facility, setFacility] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFacility = async () => {
      try {
        const { data, error: fetchErr } = await supabase
          .from('facilities')
          .select('*')
          .eq('id', id)
          .single();

        if (fetchErr || !data) throw new Error('Facility not found');
        if (!data.is_active) throw new Error('Facility account is inactive');

        // Verify session — redirect to login if not logged in
        const session = JSON.parse(localStorage.getItem('facilityUser') || '{}');
        if (session.id !== data.id) {
          navigate('/login');
          return;
        }

        setFacility(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchFacility();
  }, [id]);

  const handleLogout = () => {
    localStorage.removeItem('facilityUser');
    navigate('/login');
  };

  if (loading) return <Center minH="100vh"><Spinner size="xl" color="teal.500" /></Center>;
  if (error) return (
    <Center minH="100vh" flexDirection="column" gap={4}>
      <Text color="red.500" fontWeight="bold">{error}</Text>
      <Button onClick={() => navigate('/login')} colorScheme="teal">Go to Login</Button>
    </Center>
  );

  return (
    <Box minH="100vh" bg="gray.50">
      {/* Header */}
      <Box bg="white" borderBottom="1px" borderColor="gray.200" px={6} py={3}>
        <Flex justify="space-between" align="center">
          <HStack spacing={4} cursor="pointer" onClick={() => navigate(`/facility/${id}`)}>
            <Image src="/logo.png" alt="Logo" h="36px" fallback={<Text fontWeight="800" color="red.600" fontSize="lg">AtHome<Text as="span" color="gray.800">BloodDraw.com</Text></Text>} />
            <Text fontWeight="600" color="gray.500">|</Text>
            <Text fontWeight="700" color="teal.700">{facility?.name || 'Facility Portal'}</Text>
          </HStack>
          <HStack spacing={3}>
            <Button size="sm" variant="ghost" colorScheme="red" leftIcon={<FaSignOutAlt />} onClick={handleLogout}>
              Logout
            </Button>
          </HStack>
        </Flex>
      </Box>

      {/* Content */}
      <Box px={6} py={6}>
        <Outlet context={{ facility, facilityId: id }} />
      </Box>
    </Box>
  );
}
